<div class="container" [ngStyle]="{'flex-direction': (sideVideo=='left') ? 'row' : 'row-reverse'}">
    <div class="content">
        <p class="subtitle">{{subtitle}}</p>
        <h3>{{title}}</h3>
        <p class="text">{{text}} </p>
    </div>
    <div class="video" [innerHTML]="html" >
        
    </div>
</div>